import React from 'react';
import styles from './Alert.module.css';

export enum AlertVariant {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Pink = 'pink'
}

interface AlertProps {
  children: React.ReactNode;
  variant?: AlertVariant;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({
  children,
  variant: alertVariant = AlertVariant.Info,
  className = ''
}) => (
    <div
      className={`${styles.alert} ${styles[alertVariant]} ${className}`}
      role="alert"
    >
      {children}
    </div>
  );